var Main = function() {
  // City Show & hide ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var cityChooser = {
    cityToggle : function(){
      var cityToggleWrapper = $(".header .city"),
        cityListWrapper = $(".header .city-list"),
        cityIconArrow = $(cityToggleWrapper).find(".icon-arrow-down");
      $(cityToggleWrapper).on("click",function(e){
        if (!($(e.target).is(cityListWrapper) || $($(e.target).parents(cityListWrapper)).is(cityListWrapper))) {
          if($(window).width() > 979){
            $(cityListWrapper).fadeToggle(70);
          }
          else{
            $(cityListWrapper).slideToggle();
            $('.header .acc').not(cityListWrapper).slideUp();
          }
          if($(cityIconArrow).hasClass("icon-arrow-down")){
            $(cityIconArrow).removeClass("icon-arrow-down").addClass("icon-arrow-up");
          }
          else if($(cityIconArrow).hasClass("icon-arrow-up")){
            $(cityIconArrow).removeClass("icon-arrow-up").addClass("icon-arrow-down");
          }
        }
      });

      $(document).on("click", function(e) {
        if($(window).width() > 979){
          if ($(cityListWrapper).is(":visible")) {
            if (!($(e.target).is(cityToggleWrapper) || $($(e.target).parents(cityToggleWrapper)).is(cityToggleWrapper) ||
              $(e.target).is(cityListWrapper) || $($(e.target).parents(cityListWrapper)).is(cityListWrapper))) {
              if($(window).width() > 979){
                $(cityListWrapper).fadeOut(70);
              }
              else{
                $(cityListWrapper).slideToggle();
              }
              $(cityIconArrow).removeClass("icon-arrow-up").addClass("icon-arrow-down");
            };
          };
        };
      });
    },
    init: function() {
      this.cityToggle();
    }
  };

  // Login Show & Hide ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var login = {
    loginToggle : function(){
      var loginWrapper = $(".login-wrapper"),
        loginToggleLink = $("#login-toggle"),
        loginOverlay = $('.modal-overlay');
      $(loginToggleLink).on("click",function(){
        $('body').addClass('limit-scroll');
        $(".modal-overlay").fadeIn(400);
        loginWrapper.fadeIn(300);
        $(".modal-overlay").on("click",function(){
          $('body').removeClass('limit-scroll');
          loginWrapper.fadeOut(300);
          $(this).fadeOut(300);
        });
      });
    },
    init: function() {
      this.loginToggle();
    }
  }

  // Dropdown ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var dropdown = {
    dropdownToggle : function(){
      var dropdownDefaultText = $(".default-text");
      var dropdownControlLabel = $(".dropdown .control-label");
      dropdownDefaultText.on("mousedown",function(){
        $(".dropdown").not($(this).parents(".dropdown")).removeClass("dropdown-visible");
        $(".item-arrow", $(".dropdown").not($(this).parents(".dropdown"))).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
        $(this).parents(".dropdown").toggleClass("dropdown-visible");
        $(this).parents(".dropdown").addClass("click-flag");
        if ($(".item-arrow", $(this).parents(".dropdown")).hasClass("icon-arrow-drop-down"))
          $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-down").addClass("icon-arrow-drop-up");
        else
          $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
      });

//        dropdownDefaultText.on("focus",function(){
//          $(".dropdown").removeClass("dropdown-visible");
//          $(".item-arrow", $(".dropdown")).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
//          if(!($(this).parents(".dropdown").hasClass("click-flag"))){
//              $(this).parents(".dropdown").toggleClass("dropdown-visible");
//              if ($(".item-arrow", $(this).parents(".dropdown")).hasClass("icon-arrow-drop-down"))
//                  $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-down").addClass("icon-arrow-drop-up");
//              else
//                  $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
//          }
//        });

//        dropdownControlLabel.on("click",function(){
//          $(this).parents(".dropdown").toggleClass("dropdown-visible");
//          if ($(".item-arrow", $(this).parents(".dropdown")).hasClass("icon-arrow-drop-down")){
//              $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-down").addClass("icon-arrow-drop-up");
//          }
//          else{
//              $(".item-arrow", $(this).parents(".dropdown")).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
//          }
//        });

//        $(".dropdown").on("keydown", function(e){
//            $(".dropdown").removeClass("click-flag");
//            var keyCode = e.keyCode || e.which;
//            if (keyCode == 9) {
//                $(this).removeClass("dropdown-visible");
//                $(".item-arrow", $(this)).removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
//            }
//        });
//
//        $(".control-wrapper").on("keydown", function(e){
//            $(".dropdown").removeClass("click-flag");
//        });

      $("[class*='dropdown'] .control").on("click", function () {
        $("[class*='dropdown']").not($(this).parents("[class*='dropdown']")).removeClass("dropdown-visible");
        $("[class*='dropdown']").not($(this).parents("[class*='dropdown']")).find(".item-arrow").removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
      });

      $(document).on("click", function(e) {
        if ($(".dropdown-visible").is(":visible")) {
          if (!($(e.target).is(dropdownDefaultText.parents(".dropdown")) || $($(e.target).parents(dropdownDefaultText.parents(".dropdown"))).is(dropdownDefaultText.parents(".dropdown")))) {
            $(dropdownDefaultText.parents(".dropdown")).removeClass("dropdown-visible");
            $(".item-arrow").removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
          };
        };
      });

      $(".dropdown-items li").on("click", function(){
        if(!($(".checkbox", $(this)).length > 0)){
          var dropdownItemsParent = $(this).parents("[class*='dropdown']");
          $(".dropdown-items li", dropdownItemsParent).removeClass("active");
          $(this).addClass("active");
          dropdownItemsParent.find(".default-text [class*='value']").text($(".active", dropdownItemsParent).text());
          dropdownItemsParent.removeClass("dropdown-visible");
          $(".item-arrow").removeClass("icon-arrow-drop-up").addClass("icon-arrow-drop-down");
          var target = $('#' + $(this).data('target'));
          target.val($(".active", dropdownItemsParent).text());

        }
      });

      $(".dropdown").each(function(){
        var defaultTextVal = $(this).find(".default-text .value");
        if($(this).find(".active").length){
          defaultTextVal.text($(".active", this).text());
        }
      });

      $(".colors .color").on("click", function(){
        $(this).toggleClass("selected");
      });
    },
    init: function() {
      this.dropdownToggle();
    }
  }

  // Change Password Show/Hide ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var changePass = {
    changePassToggle : function(){
      $(".change-pass-toggle input").on("change", function(){
        if($(this).is(":checked")){
          $(".change-pass input").prop("disabled", false);
        }
        else{
          $(".change-pass input").prop("disabled", true);
        }
      });
    },
    init: function() {
      this.changePassToggle();
    }
  }

  // Address Select ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var address = {
    addressActive : function(){
      $(".address-list .item-address .text").on("click", function(){
        if(!($(this).parents(".item-address").hasClass("empty"))){
          $(".address-list .item-address").removeClass("active");
          $(this).parents(".item-address").addClass("active");
        }
        else{
          if($("#add-address").length > 0){
            $('html, body').animate({scrollTop: $("#add-address").offset().top},'slow');
          }
        }
      });
    },
    init: function() {
      this.addressActive();
    }
  }

  // Uploader ////////////////////////////////////////////////////////////////////////////////////////////////////////
  var uploader = {
    uploaderControl : function(){
      $(".uploader .uploader-text, .uploader .uploader-btn-browse").on("click", function () {
        if (!$(".uploader-btn", $(this).parents(".uploader")).hasClass('uploader-btn-remove')) {
          var uploaderInput = $(this).parents(".uploader").find("input[type='file']");
          uploaderInput.trigger("click");
        }
      });

      $(".uploader .control input[type='file']").on('change', function () {
        var fileName = this.value.replace(/\\/g, '/').replace(/.*\//, '');
        var fakepath = /fake/;
        var filesrc;
        if ('files' in this) {
          var obj = this.files[0];
          filesrc = window.URL ?
            window.URL.createObjectURL(obj) :
            window.webkitURL.createObjectURL(obj);
        } else {
          if (fakepath.test(this.value)) { // IE8 & 9
          } else {
            filesrc = this.value;
          }
        }
        $(this).next(".uploader-text").text(fileName);
        if (!this.value) {
          $(this).next(".uploader-text").text(selectLang);
          $(this).next().next(".uploader-btn").addClass("icon-upload uploader-btn-browse").removeClass("icon-close uploader-btn-remove");
        }
        else {
          $(this).next().next(".uploader-btn").removeClass("icon-upload uploader-btn-browse").addClass("icon-close uploader-btn-remove");
          $(this).parents(".uploader-wrapper").find(".uploader-preview img").attr("src", filesrc);
          $(".uploader .uploader-btn-remove").click(function () {
            $(this).parents(".uploader").find("input[type='file']").val('');
            $(this).prev(".uploader-text").text("انتخاب فایل");
            $(this).addClass("icon-upload uploader-btn-browse").removeClass("icon-close uploader-btn-remove");
            $(this).parents(".uploader-wrapper").find(".uploader-preview img").attr("src", "http://placehold.it/181x150");
          });
        }
      });
    },
    init: function() {
      this.uploaderControl();
    }
  };

  // Accordion //
  var accordion = {
    acc : function(){
      if($('.accordion').length){
        $('.accordion .block').each(function(){
          if($(this).hasClass('active')){
            $(this).find('.block-title span').removeClass('icon-arrow-down').addClass('icon-arrow-up');
          }
        });
        $('.accordion').find('.block-title').on('click', function(){
          if($(this).next('.block-cnt').is(':visible')){
            $(this).find('span').removeClass('icon-arrow-up').addClass('icon-arrow-down');
            $(this).next('.block-cnt').slideUp(300, function(){
              $(this).parent('.block').removeClass('active');
            });
          }
          else{
            $(this).find('span').removeClass('icon-arrow-down').addClass('icon-arrow-up');
            $(this).next('.block-cnt').slideDown(300);
            $(this).parent('.block').addClass('active');
          }
        });
      }
    },
    init: function() {
      this.acc();
    }
  };

  // Sticky app discount //
  var stickyAppDiscount = {
    appDiscount: function() {
      var stickyAppDiscount = $('.sticky-app-discount-wrapper');
      if(stickyAppDiscount.length > 0){
        var topOffset = stickyAppDiscount.offset().top;
        var finalTopOffset;
        $(window).scroll(function() {
          if($('.subscribe-bar').is(':visible')){
            finalTopOffset = topOffset + 68;
          }
          else{
            finalTopOffset = topOffset;
          }
          if ($(window).scrollTop() >= (finalTopOffset - 60)) {
            stickyAppDiscount.find('.sticky-app-discount').addClass('fixed');
          }
          else{
            stickyAppDiscount.find('.sticky-app-discount').removeClass('fixed');
          }
        });
      }
    },
    init: function() {
      this.appDiscount();
    }
  };

  // INIT //
  function init() {
    cityChooser.init();
    login.init();
    dropdown.init();
    changePass.init();
    //address.init(),
    uploader.init();
    accordion.init();
    stickyAppDiscount.init();
  }

  return {
    Init: init
  };
}();


// Sticky Menu //
function TKHStickyMenu(){
  this.init();

  var stickyMenuObj = this;
  var scrollHandler = _.throttle(function(){
    if($(window).width() > 979){
      if ($(window).scrollTop() >= (stickyMenuObj.navbarOffset + 70)) {
        stickyMenuObj.navBar.addClass('stick');
        stickyMenuObj.header.css('margin-bottom', stickyMenuObj.navbarHeight);
      }
      else if($(window).scrollTop() < (stickyMenuObj.navbarOffset)){
        $('.stick').css('top', '-60px');
        stickyMenuObj.navBar.removeClass('stick');
        stickyMenuObj.header.css('margin-bottom', 0);
      }
    }else{
      var headerTop = stickyMenuObj.header[0].getBoundingClientRect().top;
      if($(window).scrollTop() >= headerTop + stickyMenuObj.headerHeight){
        stickyMenuObj.mainBar.addClass('stick');
      }else if($(window).scrollTop() <= headerTop){
        stickyMenuObj.mainBar.removeClass('stick');
        stickyMenuObj.header.css('height', 'auto')
      }
    }
  },100);

  $(window).on('scroll', scrollHandler);
}

TKHStickyMenu.prototype.init = function() {
  this.navBar            = $('.nav-bar');
  this.mainBar           = $('.main-bar');
  this.header            = $('.tkh-header');
  this.headerTabs        = $('.header-tabs');
  this.mainContainer     = $('.main-container');
  this.checkOutContainer = $('.tabs.checkout');
  this.vendorWrapper     = $('.vendor-wrapper');
  this.lastScrollTop     = 0;
  this.navbarHeight      = 0;
  this.navbarOffset      = 0;

  this.mainBar.removeClass('mobile-stick');
  this.headerTabs.removeClass('mobile-stick');
  if($(window).width() > 979){
    if(this.mainContainer.hasClass('vendor-wrapper')){
      this.mainContainer.css('margin-top', 0);
    }
    else{
      // this.mainContainer.css('margin-top', 30);
    }
    // this.checkOutContainer.css('margin-top', 30);

    if(this.vendorWrapper.length){
      this.navbarHeight = this.navBar.height() + 6;
    }
    else if($('body').hasClass('tkh-full-discount-landing')){
      this.navbarHeight = this.navBar.height();
    }
    else{
      this.navbarHeight = this.navBar.height() + 30;
    }
  }

  if($('.support-24-7').length){
    this.navbarOffset = this.mainBar.height() + 50;
  }
  else{
    this.navbarOffset = this.mainBar.height();
  }

  this.mainBarHeight = this.mainBar.height();
  this.mainBar.css('top', -this.mainBarHeight);
  this.headerHeight = this.header.height();

};

$(function() {
  Main.Init();
//    if($('.table-wrapper .tkh-cart-item').length > 1){
//      $('.table-wrapper table').addClass('table-arrow-helper');
//    }
  // Progress bar in ios
  var is_ios = /(iPad|iPhone|iPod)/g.test( navigator.userAgent );
  if(is_ios)    {
    var iosProgressCss = ".main-deal .main-deal-text .discount-progress .circle{stroke: #feeeee;}.main-deal .main-deal-text .discount-progress .fill {stroke: #ff5a5f;stroke-width: 6px;}";
    $("head").append("<style>");
    $("head style").append(iosProgressCss);
  };

  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Mac') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    var iosProgressCss = ".main-deal .main-deal-text .discount-progress .circle{stroke: #feeeee !important;}.main-deal .main-deal-text .discount-progress .fill {stroke: #ff5a5f !important;stroke-width: 6px !important;}";
    $("head").append("<style>");
    $("head style").append(iosProgressCss);
  }

  // Sticky Footer ////////////////////////////////////////////////////////////////////////////////////////////////////////
  //$.stickyFooter();

  // Sticky Menu
  // $.stickyMenu();
  $.stickyMenu = new TKHStickyMenu();

  // Takhfifan Offers Slider ////////////////////////////////////////////////////////////////////////////////////////////////////////
  if($(".bjqs").length){
    $('#offers-slide').bjqs({
      animtype      : 'slide',
      animspeed     : 4000,
      width         : 1024,
      height        : 'auto',
      prevtext      : '<span class="icon-arrow-right"></span>',
      nexttext      : '<span class="icon-arrow-left"></span>',
      responsive    : true,
      showmarkers   : false
    });
  };

  if($(".bxproducts").length){
    $('.bxproducts').bxSlider({
      infiniteLoop: true,
      auto: true,
      pager: true,
      mode: 'fade',
      prevText: '',
      nextText: ''
    });
  };
  if($('.pro-categories__head').length){
    $('.pro-categories__head').click(function(){
      $(this).parent('.pro-categories').toggleClass('pro-categories--show');
    })
  }
  // Currency ////////////////////////////////////////////////////////////////////////////////////////////////////////
  if($(".currency").length){
    $(".currency").on('keyup paste', function () {
      $(this).formatCurrency({
        symbol: '',
        roundToDecimalPlace: '-2'
      });
    });
  };
  if($('.price').length){
    $(".price").on("click", function(){
      $(".currency").formatCurrency({
        symbol: '',
        roundToDecimalPlace: '-2'
      });
    });
  }
  // Price Slider ////////////////////////////////////////////////////////////////////////////////////////////////////////
  if($('.price-slider').length){
    $('.price-slider').noUiSlider({
      connect: true,
      range: {
        'min': 0,
        '3%' : 20000,
        '7%' : 40000,
        '10%': 60000,
        '14%': 80000,
        '17%': 100000,
        '20%': 120000,
        '23%': 140000,
        '26%': 160000,
        '29%': 180000,
        '32%': 200000,
        '36%': 300000,
        '39%': 400000,
        '43%': 500000,
        '46%': 600000,
        '51%': 700000,
        '54%': 800000,
        '58%': 900000,
        '61%': 1000000,
        '65%': 1100000,
        '68%': 1200000,
        '74%': 1300000,
        '78%': 1400000,
        '82%': 1500000,
        '85%': 1600000,
        '89%': 1700000,
        '93%': 1800000,
        '97%': 1900000,
        'max': 2000000
      },
      snap: true,
      start: [0, 2000000]
    });

    $('.price-slider').Link('lower').to($('#lower'), null, wNumb({
      decimals: 0,
      thousand: '،',
    }));

    $('.price-slider').Link('upper').to($('#upper'), null, wNumb({
      decimals: 0,
      thousand: '،',
    }));
  }

  $(".discount-progress").each(function(){
    var $circle = $('.fill', this), $percent = $('#percent', this), r = $circle.attr('r'), c = Math.PI*(r*2);
    var val = $(this).find('.discount-inner').attr('data-percent');
    if ( isNaN(val) ) {
      val = 100;
    } else {
      if (val < 0) { val = 0;}
      if (val > 100) { val = 100;}
      var pct = (-(0+val)/100)*c;
      $circle.css({ strokeDashoffset: pct });
    }
  });
});


// steps ////////////////////////////////////////////////////////////////////////////////////////////////////////
function stepsAction(num) {
  $(".checkout .tab-nav li").removeClass("active");
  $(".checkout .tab-nav li.tab" + num).addClass("active");
  $(".checkout .tab-cnt").hide();
  $(".checkout .tab-cnt#tab" + num).show();
};

function deals() {
  if($(".deals.res").length > 0){
    $(".col-res .res .four").appendTo(".col-res .deals.four-col");
    $(".col-res .res .five").appendTo(".col-res .deals.five-col");
    $(".col-res .res .three").appendTo(".col-res .deals.three-col");
    $(".col-res .res").remove();
  }
}
deals();

$(window).resize(
  function(){
    // $.stickyMenu();
    if(($(".deals.res").length > 0)){
      deals();
    }
    if($(window).width() > 979){
      // responsive
      moveLoginToHeader();
      $('.tkh-navigation').show().addClass('desktop');
      // $('.nav-bar').css('right', 0);
      if($('.nav-bar').hasClass('nav-bar-open') && !($('.login-wrapper').is(':visible'))){
        $('.modal-overlay').hide();
      }
      moveCityListToHeader();
      $('.header-input').show();
      $('.header-input').removeClass('mobile-search-form');
      checkoutTableHeaderRemove();
    }
    else{
      // responsive
      moveLoginTnMenu();
      $('.tkh-header .nav-bar').removeClass('stick');
      $('.tkh-navigation').removeClass('desktop');
      if($('.nav-bar').hasClass('nav-bar-open')){
        $('.modal-overlay').show();
      }
      $('.header-input').addClass('mobile-search-form');
      moveCityListToMenu();
      checkoutTableHeader();
    }

    if($(window).width() > 767){
      checkoutTableHeaderRemove();
      moveTimerToMiddleSection();
      moveConfigurableOptionsToMiddleSection();
    }
    else{
      moveTimerToButtonSection();
      moveConfigurableOptionsToDealDetails();
    }
  }
);

//set cookie for affiliate
$(document).ready(function () {
  var urlParams = new URLSearchParams(window.location.search);
  var affId = urlParams.get("affid");
  var today = new Date();
  var expDate = new Date();

  expDate.setDate(today.getDate()+Number(urlParams.get("exp")));
  if(affId && expDate){
    document.cookie = "affiliate_id=" + affId + "; expires= " + expDate + ";path=/";
  }
});

//Checkout Table Header
function checkoutTableHeader() {
  if($('.checkout .tkh-cart-item').length > 1){
    var cartHeader          = $('.table-wrapper > table').find('thead');
    var cartHeaderRowMarkup = cartHeader.find('tr').html();
    var cartTkhItemsLength  = $('.checkout .tkh-cart-item').length - 1;
    if(cartHeader.find('tr').length < $('.checkout .tkh-cart-item').length){
      for(var cartItemCounter = 0;cartItemCounter < cartTkhItemsLength;cartItemCounter++){
        cartHeader.append('<tr>' + cartHeaderRowMarkup + '</tr>');
      }
    }
  }
}

//Checkout Table Header Remove
function checkoutTableHeaderRemove() {
  var checkOutTable         = $('.checkout .table-wrapper').find('table').first();
  var checkOutTableHead     = checkOutTable.find('thead');
  var firtstCheckOutHeadRow = checkOutTableHead.find('tr').first();
  if(checkOutTableHead.find('tr').length > 1){
    checkOutTableHead.find('tr').each(function() {
      $(this).not(firtstCheckOutHeadRow).remove();
    });
  }
}

// Responsive Hamburger Menu
if($(window).width() < 979){
  checkoutTableHeader();
}

if($(window).width() > 767){
  moveTimerToMiddleSection();
  moveConfigurableOptionsToMiddleSection()
}
else{
  moveTimerToButtonSection();
  moveConfigurableOptionsToDealDetails();
}

$('#close-header-subscribe-box').on('click', function(){
  $('.header-subscribe-box').removeClass('open');
});

$('#open-header-subscribe-box').on('click', function(){
  $('.header-subscribe-box').addClass('open');
});

var headerSubslastScrollTop = 0;
function headerSubscribeBar() {
  var st = $(window).scrollTop()
  if ((st <= 0)) {
    headerSubslastScrollTop = st;
    return;
  }
  if (st > headerSubslastScrollTop){
    $('.mobile-header-subscribe-bar').removeClass('mobile-stick');
  } else {
    $('.mobile-header-subscribe-bar').addClass('mobile-stick');
  }
  headerSubslastScrollTop = st;
}

$(window).on('touchend', function() {
  if(($(window).width() < 979) && !($('.finished-hidden-cnt-container').length)){
    headerSubscribeBar();
  }
});

if($('.menu-toggle').length){
  $(document).on('click', '.menu-toggle', function() {
    if(($(window).width() < 979) && $('.menu-toggle').hasClass('menu-loaded')){
      moveLoginTnMenu();
      moveCityListToMenu();
      copyCategoriesToMenu();
    }
  });


  $('.menu-toggle').on('click', function(){
    var navBar = $('.nav-bar');
    if(navBar.hasClass('nav-bar-open')){
      navBar.removeClass('nav-bar-open').addClass('nav-bar-close');
      // navBar.css('right', 0);
      $('.modal-overlay').removeClass('no-close').fadeOut();
    }
    else if($('.menu-toggle').hasClass('menu-loaded')){
      navBar.addClass('nav-bar-open').removeClass('nav-bar-close');
      // navBar.css('right', 0);
      $('.modal-overlay').addClass('no-close').fadeIn();
    }
  });
}


$(document).on("click", function(e) {
  if($('.nav-bar').length && !($(window).width() > 979)){
    var navBar = $('.nav-bar');
    if (navBar.hasClass('nav-bar-open')) {
      if (!($(e.target).is('.menu-toggle') || $($(e.target).parents('.menu-toggle')).is('.menu-toggle') || $(e.target).is('.nav-bar') || $($(e.target).parents('.nav-bar')).is('.nav-bar') || $(e.target).is('.nav-bar') || $($(e.target).parents('.nav-bar')).is('.nav-bar'))) {
        navBar.removeClass('nav-bar-open').addClass('nav-bar-close');
        // navBar.css('right', '-90%');
        $('.modal-overlay').removeClass('no-close').fadeOut();
      }
    }
  }

});

$(document).on('click', '.category-toggle', function() {
    $('.nav-bar-mobile .tkh-navigation').slideToggle();
});

// Search open
$('.mobile-search span').on('click', function(){
  var searchWrapper = $('.header-input');
  searchWrapper.fadeIn(200);
  searchWrapper.find('input').focus();
  searchWrapper.addClass('mobile-search-form');
});

// Search close
$('.header-input .search-form > span').on('click', function(){
  var searchWrapper = $('.header-input.mobile-search-form ');
  searchWrapper.fadeOut(200);
  searchWrapper.removeClass('mobile-search-form');
});

// move login
function moveLoginTnMenu(){
  if($('.user-info').length && $('.responsive-login-wrapper').length && !$('.responsive-login-wrapper .user-info').length){
    var userInfo = $('.user-info');
    var menuLoginWrapper = $('.responsive-login-wrapper');
    userInfo.appendTo(menuLoginWrapper);
  }
}

function moveLoginToHeader(){
  if($('.user-info').length && $('.login-sec').length){
    var userInfo = $('.user-info');
    var loginSec = $('.login-sec');
    userInfo.appendTo(loginSec);
  }
}

//copy categories
function copyCategoriesToMenu(){
  if(!$('.nav-bar-mobile .tkh-navigation').length){
    $('.nav-bar-inner .tkh-navigation').clone().insertAfter( ".nav-bar-mobile .category-toggle" );
  }
}

// move city list
function moveCityListToMenu(){
  if($('.main-bar .city').length && $('.nav-bar-mobile').length){
    var cityList = $('.main-bar .city');
    // var navBar = $('.nav-bar-mobile .category-toggle');
    // cityList.appendTo(navBar);
    cityList.insertBefore( ".nav-bar-mobile .category-toggle" );
  }
}

function moveCityListToHeader(){
  if($('.nav-bar-mobile .city').length && $('.main-bar .logo').length){
    var cityList = $('.nav-bar-mobile .city');
    var logo = $('.main-bar .logo').not('.logo.vip');
    logo.after(cityList);
  }
}

function moveTimerToButtonSection(){
  if($('.deal-timer').length){
    var dealTimer = $('.deal-timer');
    $('.deal-details-left-section').append(dealTimer);
  }
}

function moveTimerToMiddleSection(){
  if($('.deal-timer').length){
    var dealTimer = $('.deal-timer');
    $('.deal-details-middle-section').append(dealTimer);
  }
}

function moveConfigurableOptionsToDealDetails(){
  if($('.tkh-configurable-options').length){
    var configurableOptions = $('.tkh-configurable-options');
    $('.deal-detail-info-wrapper .deal-details').append(configurableOptions);
  }
}

function moveConfigurableOptionsToMiddleSection(){
  if($('.tkh-configurable-options').length){
    var configurableOptions = $('.tkh-configurable-options');
    $('.deal-details-middle-section').append(configurableOptions);
  }
}


//https://github.com/davidchambers/Base64.js/blob/master/base64.js
;(function () {
  var object =
    typeof exports != 'undefined' ? exports :
      typeof self != 'undefined' ? self : // #8: web workers
        $.global; // #31: ExtendScript

  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function InvalidCharacterError(message) {
    this.message = message;
  }
  InvalidCharacterError.prototype = new Error;
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa || (
    object.btoa = function (input) {
      var str = String(input);
      for (
        // initialize result and counter
        var block, charCode, idx = 0, map = chars, output = '';
        // if the next str index does not exist:
        //   change the mapping table to "="
        //   check if d has no fractional digits
        str.charAt(idx | 0) || (map = '=', idx % 1);
        // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
        output += map.charAt(63 & block >> 8 - idx % 1 * 8)
      ) {
        charCode = str.charCodeAt(idx += 3/4);
        if (charCode > 0xFF) {
          throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
        }
        block = block << 8 | charCode;
      }
      return output;
    });

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob || (
    object.atob = function (input) {
      var str = String(input).replace(/[=]+$/, ''); // #31: ExtendScript bad parse of /=
      if (str.length % 4 == 1) {
        throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
      }
      for (
        // initialize result and counters
        var bc = 0, bs, buffer, idx = 0, output = '';
        // get next character
        buffer = str.charAt(idx++);
        // character found in table? initialize bit storage and add its ascii value;
        ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
          // and if not first of each 4 characters,
          // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
      ) {
        // try to find character in table (0-63, not found => -1)
        buffer = chars.indexOf(buffer);
      }
      return output;
    });

}());
define("main", function(){});

